<template>
  <el-select
    :value="selected"
    @input="dispatch"
    @change="emitParentEvent"
    :placeholder="'Наименование'"
    filterable
    clearable
  >
    <el-option
      v-for="item in data"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import inventory from "@/utils/mixins/components/inventory";

export default {
  mixins: [inventory],
  props: ["part", "id"],
  data() {
    return {
      data: [],
    };
  },
  mounted() {
    if (this.doctors && this.doctors.length === 0) {
      const query = { column: 'name', order: 'asc'};
      this.getInventory(query);
    }
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.filtered();
          this.selected = this.id;
        });
      },
      deep: true,
      immediate: true,
    },
    part: {
      handler: function (val, oldVal) {
        this.$emit("input", this.selected);
        this.filtered();
      },
    },
  },
  computed: {
    ...mapGetters({
      doctors: "partnerDoctor/inventory",
    }),
  },
  methods: {
    filtered() {
      const query = { part: this.part };
      this.getPartDoctor(query).then((res) => {
        this.data = res;
      });
    },
    emitParentEvent() {
      this.$emit("getDebt", true);
    },
    ...mapActions({
      getInventory: "partnerDoctor/inventory",
      getPartDoctor: "paymentBonus/getPartDoctor",
    }),
  },
};
</script>
